    // src/components/PageTitle.js
import React from 'react';

const PageTitle = ({ title }) => (
  <h2 style={{ marginBottom: 16 }}>{title}</h2>
);

export default PageTitle;
